// NOTE: Backend requires trigger.value to be a string. UI inputs (fpui-input-number,
// select) still work with numbers/other primitives — this helper runs at the API
// serialization boundary so UI state stays untouched.
export function stringifyTriggerValues (data) {
  if (!data?.triggers?.length) return data
  return {
    ...data,
    triggers: data.triggers.map(trigger => {
      if (!trigger || trigger.value === undefined || trigger.value === null) return trigger
      if (typeof trigger.value === 'string') return trigger
      return { ...trigger, value: String(trigger.value) }
    })
  }
}
